module.exports = __webpack_public_path__ + "assets/img/1.fd22f918.jpg";